module.exports = __webpack_public_path__ + "static/top-manager-4447858319058947d2a96958d2f23ab1.png";